<template>
  <div class="about">

    <div class="row">
<div id="mapid" class="col-12" ></div>
    </div>
    
  </div>
</template>
<script>

import {ApiTls} from '../../src/app/tools/ApiTls';
import {MapTls} from '../../src/app/tools/MapTls';

export default {
  name:'About',
  mounted(){
    var mymap = MapTls.initMap('mapid');
    ApiTls.startTmp(mymap,141778);
  },

}
</script>

<style scoped>
.leaflet-container {
    background: #fff;
    outline: 0;
}

.leaflet-popup-tip-container {
    display: none;
} 

#mapid{
  width: 100%;
  height: 70vh;
}
</style>
